var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentTemplate === 'grid')?[_c('div',{class:[
        'grid',
        ..._vm.gridCol,
        ..._vm.extraClass,
      ]},[_vm._t("default")],2)]:_vm._e(),(_vm.currentTemplate === 'carousel')?[_c('Carousel',{attrs:{"col":_vm.col}},[_vm._t("default")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }